import { createSelector } from "reselect";
import get from "src/lib/get";
import { getUser } from ".";

export const returnedOrdersHasError = createSelector(getUser, (data) => {
  return !!get(data, "returnedOrders.error", null);
});
